import { query } from 'qs'
import store from 'store2'
import cookie from 'cookie'

let ua = ''
let location
let navigator
if (!process.browser) {
  location = {
    host: ''
  }
  navigator = {
    userAgent: ''
  }
} else {
  location = window.location
  navigator = window.navigator
  ua = navigator.userAgent
}

module.exports = {
  setUA: function (_ua) {
    ua = _ua
  },
  // 判断是否来自第三方渠道
  isFromThird () {
    return !!cookie.get('channel') || !!query.channel
  },
  isFromqunar () {
    return query.qunar || store.session.get('qunar')
  },
  isFromLehuo () {
    let userAgent = navigator.userAgent.toLowerCase()
    return (query.lehuo ||
    (query.token && query.sourceid && query.sourcetype) ||
     cookie.get('lehuo') ||
     cookie.get('channel') === 'lehuo' ||
     /lehuo/.test(userAgent))
  },
  isFromZhaohang () {
    let userAgent = navigator.userAgent.toLowerCase()
    return /cmblife/.test(userAgent)
  },

  isFromBanma () {
    let userAgent = navigator.userAgent.toLowerCase()
    return /zebra/.test(userAgent)
  },

  isFromNonghang() {
    let userAgent = navigator.userAgent.toLowerCase()
    return /bankabc/.test(userAgent)
  },
  isMiniProgram: function () {
    if (!process.browser) {
      return false
    } else {
      return window.__wxjs_environment === 'miniprogram'
    }
  },
  isAliMiniProgram: function () {
    return this.isAliPay() && (/miniprogram/.test(navigator.userAgent.toLowerCase()) || /alipayide/.test(navigator.userAgent.toLowerCase()))
  },
  isPiaoniuAliMiniProgram: function () {
    return !query.isMiniIp && this.isAliPay() && (/miniprogram/.test(navigator.userAgent.toLowerCase()) || /alipayide/.test(navigator.userAgent.toLowerCase()))
  },
  isPiaoniuMiniProgram: function () {
    return this.isMiniProgram() && !this.isThirdMiniProgram()
  },
  isPiaoniuTiktokMiniProgram: function () {
    return !query.isMiniIp && this.isTiktok()
  },
  isThirdMiniProgram: function () {
    return this.isMiniProgram() && (query.isThirdWechatApp || store.session.get('thirdChannel'))
  },
  isWechat: function () {
    return /micromessenger/.test(navigator.userAgent.toLowerCase())
  },
  isPiaoniuH5: function() {
    return !(
      this.isWechat() ||
      this.isThirdMiniProgram() ||
      this.isPiaoniuMiniProgram() ||
      this.isAliMiniProgram() ||
      this.isMiniProgram() ||
      this.isAliPay() ||
      this.isTiktok() ||
      this.isPiaoniu()
    )
  },
  isAliPay: function () {
    return /alipayclient/.test(navigator.userAgent.toLowerCase())
  },
  isTiktok: function () {
    return /(toutiaomicroapp|bytedanceide)/.test(navigator.userAgent.toLowerCase())
  },
  isMqq: function () {
    return (/QQ/i).test(navigator.userAgent)
  },
  isWeibo: function () {
    return /Weibo/.test(navigator.userAgent)
  },
  /**
   * 斑马会员因为ua只有一个zebra
   * 页面跳转的时候会跳转到PC
   * 先记个todo
   */
  isMobile: function () {
    return /Mac|Windows|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini|zebra/i.test(navigator.userAgent)
  },
  isIOS: function () {
    return ua.match('iPhone')
  },
  isWanda: function () {
    let WANDA = 'wanda'
    if (process.browser) {
      var cookie = require('cookie').default
      return cookie.get('channel') === WANDA || query.channel === WANDA
    } else {
      return false
    }
  },
  isAndroid: function () {
    return !!ua.match(/android/i)
  },
  isPiaoniuMerchant () {
    return !!ua.match('PiaoniuMerchantClient')
  },
  isPiaoniu: function () {
    return !!ua.match('piaoniu')
  },
  isDouban: function () {
    return !!ua.match('com.douban')
  },
  isDev: function () {
    return location.host.indexOf('lc') === 0
  },
  isBeta: function () {
    return location.host.indexOf('beta') !== -1 || location.host.indexOf('lc') !== -1 || location.host.indexOf('localhost') !== -1
  },
  isProduct: function () {
    return location.host == 'm.piaoniu.com' || location.host == 'www.piaoniu.com'
  },
  isDebug: function () {
    return !!location.search.match('debug')
  },
  version: function () {
    if (this.isPiaoniu()) {
      let match = ua.match(/com\.ipiaoniu\.[\w.]+\/([\d.]+)/)
      return match ? match[1] : null
    } else {
      return null
    }
  },
  versionGreaterThanOrEqualTo: function (version) {
    var v = this.version()
    if (!v) {
      return false
    } else {
      let v1Splited = v.split('.').map(Number)
      let v2Splited = version.split('.').map(Number)
      for (let i = 0; i <= 2; i++) {
        if (v1Splited[i] > v2Splited[i]) {
          return true
        } else if (v1Splited[i] < v2Splited[i]) {
          return false
        }
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/mods/ua.js